import React, { useEffect, useState } from "react";

function QuizTimer({ onExpire }) {
    const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes

    useEffect(() => {
        if (timeLeft <= 0) {
            onExpire();
            return;
        }
        const timer = setInterval(() => setTimeLeft((t) => t - 1), 1000);
        return () => clearInterval(timer);
    }, [timeLeft]);

    const format = (s) => `${Math.floor(s / 60)}:${("0" + (s % 60)).slice(-2)}`;

    return <div>⏳ Time Left: {format(timeLeft)}</div>;
}

export default QuizTimer;
